import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { API_BASE_URL } from "../../utils/config";
import { useNavigate } from 'react-router-dom';

function CreateUsersUsingCsv() {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  // 
  let bearerToken = localStorage.getItem('jwt_token');
  const navigate = useNavigate();
  //
  const config = {


    headers: {
      'Authorization': `Bearer ${bearerToken}`,
      'Content-Type': 'multipart/form-data',
      // 'X-Wp-Nonce': '6de9be6ced',
      // 'Content-Type': 'application/json',

    }

  };
  // 

  useEffect(() => {
    if (!bearerToken) {
      navigate('/')
    }
  }, [])

  const handleUpload = () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append('file', selectedFile);

      axios.post(`${API_BASE_URL}/wp-json/custom-csv-import/v1/import`, formData, config)
        .then(response => {
          // Handle the response here
          console.log(response)
        })
        .catch(error => {
          // Handle any errors here
        });
    }
  };

  return (
    <div>
      <h1>Upload users</h1>
      {/* <Form> */}
      {/* <Form.Group> */}
      <input
        type='file'
        id="csvFile"
        label="Choose a CSV file to upload"
        onChange={handleFileChange}
      />
      {/* </Form.Group> */}
      <Button variant="primary" onClick={handleUpload}>
        Upload
      </Button>
      {/* </Form> */}
    </div>
  );
}

export default CreateUsersUsingCsv;
